(function () {
	const roots = document.querySelectorAll('[data-resource-library-search]');
	if (!roots.length) {
		return;
	}

	const MAX_SUGGESTIONS = 5;

	function getGridSearchInput() {
		return document.querySelector('.resources__search-input');
	}

	function getGridRoot() {
		return document.getElementById('all-resources');
	}

	function scrollToGrid() {
		const grid = getGridRoot();
		if (!grid) {
			return;
		}
		grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	function syncToGridSearch(value, shouldScroll) {
		const gridSearch = getGridSearchInput();
		if (!gridSearch) {
			return false;
		}

		if (gridSearch.value !== value) {
			gridSearch.value = value;
			gridSearch.dispatchEvent(new Event('input', { bubbles: true }));
		}

		if (shouldScroll) {
			scrollToGrid();
		}

		return true;
	}

	function buildLibrarySearchUrl(libraryUrl, query) {
		const url = new URL(libraryUrl, window.location.origin);
		url.searchParams.set('q', query);
		return url.pathname + url.search;
	}

	function parseIndex(root) {
		try {
			const raw = root.dataset.resourcesIndex || '[]';
			const parsed = JSON.parse(raw);
			return Array.isArray(parsed) ? parsed : [];
		} catch (error) {
			return [];
		}
	}

	function escapeHtml(value) {
		return String(value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	function titleMatchScore(title, query) {
		const normalizedTitle = title.toLowerCase();
		const normalizedQuery = query.toLowerCase();

		if (normalizedTitle === normalizedQuery) {
			return 1000;
		}
		if (normalizedTitle.startsWith(normalizedQuery)) {
			return 500;
		}
		if (normalizedTitle.includes(normalizedQuery)) {
			return 300;
		}

		const words = normalizedTitle.split(/\s+/);
		if (words.some(function (word) {
			return word.startsWith(normalizedQuery);
		})) {
			return 200;
		}

		return 0;
	}

	function findSuggestions(index, query) {
		if (!query) {
			return [];
		}

		return index
			.map(function (item) {
				const title = String(item.title || '').trim();
				const url = String(item.url || '').trim();
				if (!title || !url) {
					return null;
				}

				const score = titleMatchScore(title, query);
				if (!score) {
					return null;
				}

				return { title: title, url: url, score: score };
			})
			.filter(Boolean)
			.sort(function (a, b) {
				if (b.score !== a.score) {
					return b.score - a.score;
				}
				return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true });
			})
			.slice(0, MAX_SUGGESTIONS);
	}

	roots.forEach(function (root) {
		const form = root.querySelector('.resource-library-search__form');
		const input = root.querySelector('.resource-library-search__input');
		const results = root.querySelector('.resource-library-search__results');
		const libraryUrl = root.dataset.libraryUrl || '/resources/library/';
		const index = parseIndex(root);

		if (!form || !input || !results) {
			return;
		}

		let debounceTimer = null;
		let activeIndex = -1;

		function hideResults() {
			results.hidden = true;
			results.innerHTML = '';
			input.setAttribute('aria-expanded', 'false');
			activeIndex = -1;
		}

		function renderResults(matches) {
			if (!matches.length) {
				hideResults();
				return;
			}

			results.innerHTML = matches.map(function (match, index) {
				return '<a class="resource-library-search__result" role="option" href="' +
					escapeHtml(match.url) + '" data-suggestion-index="' + index + '">' +
					escapeHtml(match.title) + '</a>';
			}).join('');

			results.hidden = false;
			input.setAttribute('aria-expanded', 'true');
			activeIndex = -1;
		}

		function updateSuggestions() {
			const query = input.value.trim();
			renderResults(findSuggestions(index, query));
		}

		function highlightActiveOption() {
			const options = results.querySelectorAll('.resource-library-search__result');
			options.forEach(function (option, index) {
				option.classList.toggle('is-active', index === activeIndex);
				if (index === activeIndex) {
					option.setAttribute('aria-selected', 'true');
				} else {
					option.removeAttribute('aria-selected');
				}
			});
		}

		input.addEventListener('input', function () {
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(updateSuggestions, 150);
		});

		input.addEventListener('keydown', function (event) {
			const options = results.querySelectorAll('.resource-library-search__result');
			if (results.hidden || !options.length) {
				return;
			}

			if (event.key === 'ArrowDown') {
				event.preventDefault();
				activeIndex = Math.min(activeIndex + 1, options.length - 1);
				highlightActiveOption();
			} else if (event.key === 'ArrowUp') {
				event.preventDefault();
				activeIndex = Math.max(activeIndex - 1, 0);
				highlightActiveOption();
			} else if (event.key === 'Enter' && activeIndex >= 0) {
				event.preventDefault();
				const activeOption = options[activeIndex];
				if (activeOption && activeOption.href) {
					window.location.href = activeOption.href;
				}
			} else if (event.key === 'Escape') {
				hideResults();
			}
		});

		input.addEventListener('focus', function () {
			if (input.value.trim()) {
				updateSuggestions();
			}
		});

		document.addEventListener('click', function (event) {
			if (!root.contains(event.target)) {
				hideResults();
			}
		});

		results.addEventListener('mousedown', function (event) {
			event.preventDefault();
		});

		form.addEventListener('submit', function (event) {
			const query = input.value.trim();
			if (!query) {
				event.preventDefault();
				hideResults();
				return;
			}

			if (activeIndex >= 0) {
				event.preventDefault();
				const activeOption = results.querySelector('.resource-library-search__result.is-active');
				if (activeOption && activeOption.href) {
					window.location.href = activeOption.href;
				}
				return;
			}

			hideResults();

			if (syncToGridSearch(query, true)) {
				event.preventDefault();
				return;
			}

			event.preventDefault();
			window.location.href = buildLibrarySearchUrl(libraryUrl, query);
		});

		const params = new URLSearchParams(window.location.search);
		const queryParam = params.get('q');
		if (queryParam) {
			input.value = queryParam;
			syncToGridSearch(queryParam, false);
		}
	});
})();
